export const CacheKeys = {
    EQUIPO_PAGE: 'EQUIPO_PAGE',
};

export const CacheExpirationTimes = {
    [CacheKeys.EQUIPO_PAGE]: 300000, // 5 minutos
};

export const getExpirationTime = (key) => {
    return Date.now() + CacheExpirationTimes[key];
};

const times = {
    MINUTO_1: 60,
    MINUTO_5: 300,
    MINUTO_10: 600,
    MINUTO_30: 1800,
    HORA_1: 3600,
    HORA_2: 7200,
    HORA_6: 21600,
    HORA_12: 43200,
    HORA_24: 86400,
    MES_1: 2592000,
};

export const RevalidationTimes = {
    MINUTO_1: 60,
    MINUTO_5: 300,
    MINUTO_10: 600,
    MINUTO_30: 1800,
    HORA_1: 3600,
    HORA_2: 7200,
    HORA_6: 21600,
    HORA_12: 43200,
    HORA_24: 86400,
    MES_1: 2592000,
};

export const IsrRevalidateTime = {
    NOTICIAS_FLASH: times.MINUTO_5, // 5 minutos
    ALINEACIONES_PROBABLES: times.MINUTO_10, // 5 minutos
    JUGADORES_LESIONADOS: times.MINUTO_10, // 5 minutos
    JUGADORES_DUDAS: times.MINUTO_10, // 5 minutos
    JUGADORES_APERCIBIDOS: times.MINUTO_10, // 5 minutos
    JUGADORES_SANCIONADOS: times.MINUTO_10, // 5 minutos
    CALENDARIO_COMPETICIONES: times.HORA_1, // 6 horas
    CALENDARIO_FANTASY: times.HORA_1, // 6 horas
    MEJORES_RACHAS: times.HORA_1, // 1 hora
    PUJA_IDEAL_FANTASY: times.MINUTO_5, // 5 minutos
    PUJA_IDEAL_BIWENGER: times.MINUTO_30, // 5 minutos
    CHOLLOS_FANTASY: times.HORA_6, // 5 minutos
    CHOLLOS_BIWENGER: times.HORA_6, // 5 minutos
    VIRUS_FIFA: times.HORA_1, // 6 horas
    BIWENGER_ESTADISTICAS: times.HORA_12, // 6 horas
    HOME_PAGE: 300, // 1 minuto
    ACTIVIDADES_PAGE: times.MINUTO_1, // 1 minuto
    MERCADO_FANTASY: times.MINUTO_1, // 1 minuto
    BIWENGER_MERCADO: times.HORA_2, // 1 minuto
    LANZADORES_PENALTIS: times.HORA_6, // 1 minuto
    EQUIPO_PAGE: times.MINUTO_1, // 1 minuto
    ORACULO_FANTASY: times.MINUTO_5, // 1 minuto
    ESTADISTICAS_FANTASY_PARTIDO: 300, // 5 minutos
    ALINEACIONES_PARTIDO_PAGE: 300, // 1 minuto
    PUBLIC_TIERLISTS: times.MINUTO_5, // 1 minuto
    VISUALIZAR_TIERLIST: times.MINUTO_5, // 1 minuto
    NOTICIAS: times.MINUTO_5, // 1 minuto
    Puntuaciones_Fantasy_Jornada: times.HORA_1, // 1 minuto
    PREMIUM_ANALYSIS: times.MINUTO_10, // 1 minuto
    PREMIUM_DASHBOARD: times.HORA_1, // 1 minuto
    PREMIUM_ANALYSIS_SINGLE: times.MINUTO_10, // 1 minuto
    JUGADORES_PAGE: times.HORA_1, // 1 minuto
    ALINEACIONES_PROBABLES_PAGE: times.HORA_1, // 1 minuto
    SALDO_ARBITRAL_PAGE: times.HORA_6, // 1 minuto
    STANDING_OLD: times.MES_1, // 1 mes
    STANDING_NEW: times.HORA_1, // 1 hora
    CREADOR_DE_CONTENIDO_PAGE: times.MINUTO_10, // 10 minutos
    GUIA_FANTASY: times.HORA_12, // 10 minutos
    PREDICCION_PARTIDO: times.MINUTO_5, // 5 minutos
};
